import Client from './Client';

export default class DocutaxClient {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  firstName;

  /**
   * @type {string}
   */
  lastName;

  /**
   * @type {string}
   */
  cellPhone;

  /**
   * @type {string}
   */
  emailAddress;

  /**
   * @type {boolean}
   */
  verified = false;

  /**
   * @type {number}
   */
  selectedOfficeId;

  /**
   * @type {string}
   */
  selectedOfficeEfin;

  /**
   * @type {string}
   */
  selectedOfficeUserId;

  /**
   * @type {number}
   */
  threePClientId;

  /**
   * @type {object}
   */
  createdDate;

  /**
   * @type {object}
   */
  signupCompletionDate;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.firstName != null) {
        this.firstName = opts.firstName;
      }
      if (opts.lastName != null) {
        this.lastName = opts.lastName;
      }
      if (opts.cellPhone != null) {
        this.cellPhone = opts.cellPhone;
      }
      if (opts.emailAddress != null) {
        this.emailAddress = opts.emailAddress;
      }
      if (opts.verified != null) {
        this.verified = opts.verified;
      }
      if (opts.selectedOfficeId != null) {
        this.selectedOfficeId = opts.selectedOfficeId;
      }
      if (opts.selectedOfficeEfin != null) {
        this.selectedOfficeEfin = opts.selectedOfficeEfin;
      }
      if (opts.selectedOfficeUserId != null) {
        this.selectedOfficeUserId = opts.selectedOfficeUserId;
      }
      if (opts.threePClientId != null) {
        this.threePClientId = opts.threePClientId;
      }
      if (opts.createdDate != null) {
        this.createdDate = opts.createdDate;
      }
      if (opts.signupCompletionDate != null) {
        this.signupCompletionDate = opts.signupCompletionDate;
      }
    }
  }

  /**
   * @param {Client} threePClient
   */
  static initFromThreePClient(threePClient) {
    threePClient = new Client(threePClient);

    const client = new DocutaxClient();
    client.firstName = threePClient.firstName;
    client.lastName = threePClient.lastName;
    client.cellPhone = threePClient.cellPhone;
    client.emailAddress = threePClient.email;
    client.threePClientId = threePClient.id;
    client.selectedOfficeId = threePClient.officeId;
    client.selectedOfficeEfin = threePClient.officeEfin;

    return client;
  }

  toString() {
    const name = [this.firstName, this.lastName]
      .filter(part => !!part && part.length)
      .join(' ');

    return [name, this.cellPhone, this.emailAddress]
      .filter(part => !!part && part.length)
      .join(' - ');
  }
}
